import Vue from 'vue'
import Router from 'vue-router'
import App from './App'
import router from './router' 
import AuthService from './msal'

var urlParams = new URLSearchParams(location.search);
Vue.prototype.$AuthService = new AuthService()
if (urlParams.has('type')){
  if (urlParams.get('type')=='logout'){    
    Vue.prototype.$AuthService.logout()
  }
}
Vue.prototype.$AuthService.login()     
Vue.config.productionTip = false
Vue.use(Router)
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js